import React from 'react'
import styles from './SignUpModal.module.scss'
import Type from '../../Type'
import Hide from '../../Hide'
import ButtonStandard from '../../ButtonStandard'
import { func, bool } from 'prop-types'

function SubscribeMessage({ existingSubscriber, onClose }) {
  return (
    <div className={styles.Subscribed}>
      <Type size="body2">
        {existingSubscriber
          ? 'You are already subscribed to our newsletter. Keep an eye on your inbox for the latest news and analysis...'
          : 'You are now subscribed to the newsletter! Look out for an email from us directing you to the next steps...'}
      </Type>
      <Hide at="desktop">
        <ButtonStandard
          outline
          inverse
          size="bloated"
          onClick={onClose}
          className={styles.Submit}
        >
          OK
        </ButtonStandard>
      </Hide>
    </div>
  )
}

SubscribeMessage.propTypes = {
  onClose: func.isRequired,
  existingSubscriber: bool.isRequired
}

export default SubscribeMessage
